<template>
  <DocumentEditionPage
      :business="business"
      :client-name="clientName"
      :active-category="activeCategory"
      :active-document-number="activeDocumentNumber"
      :is-editable="false"
      :title-input="titleInput"
      :business-elements="businessElements"
      :totals="totals"
      :default-unit-price="defaultUnitPrice"
      :default-tva-percent="defaultTvaPercent"
  />
</template>

<script>
import DocumentEditionPage from "@/components/businessEdition/DocumentEditionPage.vue";
import {BUSINESS_DOCUMENT_TYPE_ENUM} from "@/models/businessDocumentTypeEnum";
import {wrapElements} from "@/components/businessEdition/documentElementsMapper";
import {isDepositAborted} from "@/models/depositStatusEnum";

export default {
  name: 'InvoiceDocument',
  components: {DocumentEditionPage},
  props: {
    business: {type: Object, default: undefined},
    clientName: {type: String, default: ''},
    defaultUnitPrice: {default: undefined},
    defaultTvaPercent: {default: undefined},
  },
  computed: {
    activeCategory() {
      return BUSINESS_DOCUMENT_TYPE_ENUM.INVOICE.label;
    },
    activeDocumentNumber() {
      return this.business ? this.business.invoiceNumber : '';
    },
    titleInput() {
      return {label: 'Titre', value: this.business ? this.business.title : '', type: 'text', readOnly: true};
    },
    businessElements() {
      const elements = wrapElements(this.business ? this.business.elements : [], true);

      if (this.business && this.business.depositNumber && !isDepositAborted(this.business)) {
        elements.push({
          type: 'element',
          text: {value: 'Acompte', type: 'text', readOnly: true},
          durationQuantity: {value: 1, type: 'number', step: 0.25, readOnly: true},
          unitPrice: {value: -this.business.deposit, type: 'number', step: 0.25, readOnly: true},
          discountedRate: {value: 0, type: 'number', readOnly: true},
          tva: {value: 0, type: 'number', readOnly: true},
          amount: {value: -this.business.deposit, type: 'number', readOnly: true},
        });
      }

      return elements;
    },
    totals() {
      return {
        htAmount: this.business.htAmount,
        tvaAmount: this.business.tvaAmount,
        ttcAmount: this.business.ttcAmount,
      };
    },
  },
};
</script>